
	import { defineComponent, watch, ref, onMounted } from 'vue'
	import { getAccountList } from '../../calloutLine/request'

	export default defineComponent({
		props: {
			name: {
				type: [String, Array],
				default: ''
			},
			filter: {
				type: Object,
				default: () => ({})
			},
			value: {
				type: Object,
				default: () => ({})
			},
			num: {
				type: String,
				default: ''
			},
			required: {
				type: Boolean,
				default: false
			},
			size: {
				type: String,
				default: 'small'
			}
		},
		emits: ['update:value', 'update:num'],
		setup(props, { emit }) {
			const selectValue = ref<string | undefined>(undefined)
			const options = ref([])

			const fetchList = async () => {
				const { data } = await getAccountList({ ...props.filter, isEnabled: 1 })
				options.value = data.map((item) => {
					return {
						...item,
						value: item.num,
						label: item.account || '其他'
					}
				})
				handleSelectValue()
			}

			const handleSelectValue = () => {
				if (props.num) {
					selectValue.value = props.num
					syncConfigValue()
				}
			}

			const changeSelect = (val) => {
				const obj: any = options.value?.find((item: any) => item.value == val) || {}
				emit('update:value', JSON.parse(obj?.configJson || null))
				emit('update:num', obj?.num)
			}

			const syncConfigValue = () => {
				const obj: any = options.value?.find((item: any) => item.value == props.num) || {}
				emit('update:value', JSON.parse(obj?.configJson || null))
				console.log(JSON.parse(obj?.configJson || null))
			}

			watch(
				() => props.num,
				() => {
					handleSelectValue()
				}
			)

			onMounted(() => {
				fetchList()
			})

			return {
				changeSelect,
				options,
				selectValue
			}
		}
	})
